// extracted by mini-css-extract-plugin
export default {"main":"SubLayout_main__PZISc","bg":"SubLayout_bg__6+Qbx","image":"SubLayout_image__QLlc-","white_line":"SubLayout_white_line__1KWkb"};